module.exports = __webpack_public_path__ + "img/add-member-plus-checked.790ce83d.svg";